var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col" },
    [
      _c("p", { staticClass: "step-caption ft-bld" }, [
        _vm._v("Choose how you want to monetize your content for your users"),
      ]),
      _vm._v(" "),
      _vm._l(_vm.plans, function (plan, index) {
        return _c("SelectWrapper", {
          key: index,
          staticClass: "tag-selecter",
          attrs: {
            item: plan.name,
            caption: plan.description,
            forcedOne: true,
            "billed-price": _vm.displayPrices(plan),
          },
          on: {
            input: function ($event) {
              return _vm.selectPlan(index)
            },
          },
          model: {
            value: plan.selected,
            callback: function ($$v) {
              _vm.$set(plan, "selected", $$v)
            },
            expression: "plan.selected",
          },
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "new-plan",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.addPlan.apply(null, arguments)
            },
          },
        },
        [
          _c("span", { staticClass: "ico" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "34",
                  height: "34",
                  viewBox: "0 0 34 34",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34ZM15.5 15.5V9.5H18.5V15.5H24.5V18.5H18.5V24.5H15.5V18.5H9.5V15.5H15.5Z",
                    fill: "url(#paint0_linear_1549_381)",
                  },
                }),
                _vm._v(" "),
                _c(
                  "defs",
                  [
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "paint0_linear_1549_381",
                          x1: "34",
                          y1: "34",
                          x2: "-2.87718",
                          y2: "30.524",
                          gradientUnits: "userSpaceOnUse",
                        },
                      },
                      [
                        _c("stop", { attrs: { "stop-color": "#F3CA54" } }),
                        _vm._v(" "),
                        _c("stop", {
                          attrs: { offset: "1", "stop-color": "#FFBB36" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "txt ft-bld txt-main" }, [
            _vm._v("Add a new subscription plan"),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nxt-out" }, [
        _c(
          "div",
          {
            staticClass: "btn bck",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.switchStep("prv")
              },
            },
          },
          [_c("span", { staticClass: "txt" }, [_vm._v("Back")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn main txt-blk",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
          },
          [
            _c("span", { staticClass: "hvr" }),
            _vm._v(" "),
            _c("span", { staticClass: "txt" }, [_vm._v("All done!")]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }